import React from 'react';
import FlowRendererField from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererField';

/* Utilities */
import { trans } from 'js/utilities';

export default function ConversionFlowComponentAccessories({ component, path, id, ...passProps }) {
    const hasAccessories = component?.fields?.length > 0;

    return (
        <div className="col-12">
            <div className="row row--bordered gutters-4 pb-6">
                {hasAccessories ? (
                    <FlowRendererField
                        component={component}
                        fields={component.fields}
                        path={`${path}.fields`}
                        id={`${id}.fields`}
                        {...passProps}
                    />
                ) : (
                    <div className="col-12">
                        <p className="text--14 text--xl-16 mb-0">
                            {trans('conversions.accessories.no_accessories')}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}
